<template>
  <div
    :class="
      twMerge(
        'container mx-auto px-4 lg:container',
        typeof $attrs.class === 'string' ? $attrs.class : undefined,
      )
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>
